import React from 'react'

export const VisibilityIcon = (color = '#495863', width = 24, height = 16) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 16"
      fill="none"
    >
      <g clipPath="url(#clip0_6557_12992)">
        <path
          d="M24 8.17993C23.78 8.44993 23.57 8.72993 23.35 8.99993C23.15 9.25993 22.96 9.52993 22.73 9.75993C22.09 10.4099 21.47 11.0799 20.79 11.6899C19.77 12.6099 18.67 13.4399 17.48 14.1199C16.55 14.6499 15.59 15.1199 14.56 15.4199C13.85 15.6299 13.12 15.7799 12.38 15.8399C11.35 15.9199 10.34 15.8699 9.33 15.6499C7.73 15.3099 6.3 14.6199 4.93 13.7599C4.12 13.2499 3.33 12.6999 2.63 12.0399C1.89 11.3499 1.13 10.6699 0.44 9.92993C-0.1 9.38993 -0.53 8.76993 -1 8.17993C-1 8.01993 -1 7.85993 -1 7.68993C-0.4 6.96993 0.18 6.23993 0.79 5.54993C1.18 5.09993 1.6 4.66993 2.06 4.28993C2.82 3.64993 3.59 3.00993 4.4 2.44993C5.11 1.95993 5.88 1.52993 6.66 1.15993C7.32 0.839929 8.03 0.629929 8.73 0.389929C9.37 0.169929 10.04 0.109929 10.71 0.0399286C11.58 -0.0500714 12.43 0.0499286 13.29 0.189929C14.71 0.409929 16.02 0.939929 17.25 1.64993C18.11 2.14993 18.94 2.71993 19.72 3.32993C20.55 3.97993 21.33 4.68993 22.07 5.43993C22.7 6.06993 23.24 6.77993 23.82 7.45993C23.89 7.54993 23.94 7.65993 24 7.75993V8.19993V8.17993ZM1.91 7.91993C2.14 8.18993 2.34 8.44993 2.57 8.67993C3.44 9.56993 4.31 10.4499 5.31 11.1899C6.51 12.0799 7.79 12.8399 9.24 13.2699C10.07 13.5099 10.91 13.6699 11.79 13.5999C12.52 13.5499 13.23 13.4399 13.9 13.1999C14.67 12.9299 15.43 12.5999 16.14 12.1999C17.38 11.4999 18.48 10.5999 19.5 9.60993C19.82 9.29993 20.12 8.96993 20.42 8.64993C20.63 8.41993 20.84 8.16993 21.04 7.92993C20.84 7.68993 20.66 7.45993 20.45 7.24993C20.04 6.81993 19.63 6.38993 19.18 5.98993C18.59 5.46993 17.99 4.94993 17.36 4.47993C16.44 3.77993 15.43 3.22993 14.35 2.81993C13.34 2.43993 12.29 2.23993 11.2 2.27993C11.06 2.27993 10.91 2.31993 10.77 2.31993C10.18 2.32993 9.62 2.48993 9.06 2.65993C8.26 2.90993 7.51 3.25993 6.79 3.66993C5.92 4.16993 5.12 4.76993 4.37 5.41993C3.91 5.81993 3.49 6.24993 3.06 6.67993C2.67 7.07993 2.29 7.48993 1.91 7.89993V7.91993Z"
          fill={color}
        />
        <path
          d="M11.4501 12.0601C9.1601 12.0901 7.5301 10.2101 7.3601 8.37006C7.2501 7.12006 7.6101 6.03006 8.4601 5.11006C9.2301 4.28006 10.2001 3.84006 11.3301 3.82006C13.8101 3.77006 15.5501 5.66006 15.6101 7.82006C15.6801 10.1801 13.7401 12.1001 11.4401 12.0601H11.4501Z"
          fill={color}
        />
      </g>
      {/* <defs>
        <clipPath id="clip0_6557_12992">
          <rect
            width="25"
            height="15.87"
            fill="white"
            transform="translate(-1)"
          />
        </clipPath>
      </defs> */}
    </svg>
  )
}
